__turbopack_context__.v({
  "benzingaBriefs": "BenzingaBriefs-module-scss-module__YED33W__benzingaBriefs",
  "benzingaBriefsHeader": "BenzingaBriefs-module-scss-module__YED33W__benzingaBriefsHeader",
  "briefDate": "BenzingaBriefs-module-scss-module__YED33W__briefDate",
  "briefListItem": "BenzingaBriefs-module-scss-module__YED33W__briefListItem",
  "briefListItemTextContent": "BenzingaBriefs-module-scss-module__YED33W__briefListItemTextContent",
  "briefTitle": "BenzingaBriefs-module-scss-module__YED33W__briefTitle",
  "readMore": "BenzingaBriefs-module-scss-module__YED33W__readMore",
  "tickerList": "BenzingaBriefs-module-scss-module__YED33W__tickerList",
});
